import React from "react"
import tw, { styled } from "twin.macro"
import "react-step-progress-bar/styles.css"
import { ProgressBar } from "react-step-progress-bar"
const Container = styled.div`
	${tw`py-1`}
`

const BarScore = ({ score }) => {

    var colour

    if (score >= 80) {
        colour = "#68d391"
    } else if (score < 80 && score >= 60) {
        colour = "#f6e05e"
    } else if (score < 60 && score >= 40) {
        colour = "#ff9f0A"
    } else if (score < 40) {
        colour = "#e53e3e"
    }

	return (
		<Container>
            <ProgressBar percent={score} filledBackground={colour} />
		</Container>
	)
}

export default BarScore